import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Modal } from '../../canvasComponents/index';
import { FEbaseURL } from '../../config';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './messages';

function ErrorPopupGeneric({ isSave = true, open, closeErrorPopUp, intl }) {
  const onPopUpClose = () => {
    closeErrorPopUp();
    window.open(`${FEbaseURL}/dashboard`, '_self');
  };

  return (
    <Modal
      ariaHideApp={false}
      id="errorModal"
      isOpen={open}
      onRequestClose={() => onPopUpClose()}
    >
      <div>
        <div className="pop-up-title">
          <FormattedMessage {...messages.title} />
        </div>
        <div className="pop-up-text margin-text-bottom">
          {isSave ? <FormattedMessage {...messages.textSave} /> : <FormattedMessage {...messages.textNoSave} />}
          <a style={{ textDecoration: 'none' }} href={`tel:${intl.formatMessage(messages.phoneNumber)}`}><FormattedMessage {...messages.phoneNumber} /></a>.
        </div>
        <Button
          primary
          className="pop-up-btn"
          onClick={() => onPopUpClose()}
        >
          <FormattedMessage {...messages.btn} />
        </Button>
        <div className="error-pop-up-call">
          <a href={`tel:${intl.formatMessage(messages.phoneNumber)}`}>
            <FormattedMessage {...messages.callUs} />
          </a>
        </div>
      </div>
    </Modal>
  );
}

export default injectIntl(ErrorPopupGeneric);
